import Icon, { IconNames } from "components/Icon/Icon";

interface ISectionTitle {
  title: string;
  icon?: IconNames;
  className?: string;
}

function SectionTitle({ title, icon, className = "" }: ISectionTitle) {
  return (
    <h3
      className={`text-lg font-semibold text-primary mb-4 flex items-center gap-2 ${className}`}
    >
      {icon && <Icon name={icon} className="w-5 h-5" />}
      {title}
    </h3>
  );
}

export default SectionTitle;
